import StringUtils from "./StringUtils";

const EQUALS_ERROR = 0.0001;

class NumberUtils {

    public static isNaN(value: any): boolean {
        if (value == null || ('' + value).trim().length == 0) {
            return true;
        }

        let valueAny: any = value;
        return isNaN(valueAny);
    }

    public static inside(value: number, l: number, r: number) {
        return (l < value && value < r) || (r < value && value < l);
    }

    public static numberToString(num: number): string {
        if (num == null) {
            return '';
        }

        return num.toString();
    }

    public static compare(a: number, b: number): number {
        let diff = a - b;
        if (Math.abs(diff) < EQUALS_ERROR) {
            return 0;
        }

        return diff;
    }

    public static equals(a: number, b: number): boolean {
        return NumberUtils.compare(a, b) == 0;
    }

    public static indexOf(nums: number[], target: number): number {
        for (let i = 0; i < nums.length; i++) {
            let num = nums[i];
            if (NumberUtils.equals(num, target)) {
                return i;
            }
        }

        return -1;
    }
}

export default NumberUtils;